import { render, staticRenderFns } from "./NoChatInformation.vue?vue&type=template&id=6bb52850&scoped=true&"
import script from "./NoChatInformation.vue?vue&type=script&lang=js&"
export * from "./NoChatInformation.vue?vue&type=script&lang=js&"
import style0 from "./NoChatInformation.vue?vue&type=style&index=0&id=6bb52850&prod&lang=css&"
import style1 from "./NoChatInformation.vue?vue&type=style&index=1&id=6bb52850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb52850",
  null
  
)

export default component.exports